var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-pizza-tracker/src/PizzaTracker.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import { NikeStylesContext } from '@nike/nr-sole-xl-theme-provider';
import PizzaTrackerPure from './PizzaTrackerPure';
import defaultStyles from './styles';

var PizzaTracker = function PizzaTracker(_ref) {
  var styleExtension = _ref.styleExtension,
      rest = _objectWithoutProperties(_ref, ["styleExtension"]);

  return React.createElement(NikeStylesContext.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }, function (_ref2) {
    var attributes = _ref2.attributes,
        mergeStyles = _ref2.mergeStyles,
        globalStyleExtension = _ref2.styleExtension;
    var styles = mergeStyles(attributes, defaultStyles, globalStyleExtension.PizzaTracker, styleExtension);
    return React.createElement(PizzaTrackerPure, _extends({
      styles: styles
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      },
      __self: this
    }));
  });
};

PizzaTracker.propTypes = {
  /** Passed down to all DOM elements to allow E2E testing. */
  'data-e2e': PropTypes.string,

  /** Component ID. */
  id: PropTypes.string,

  /** The array of our statuses to display */
  stepItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    indicator: PropTypes.oneOf(['danger', 'default', 'success', 'warning'])
  })).isRequired,

  /** The icon to use in the success indicator */
  successIcon: PropTypes.shape({}),

  /** Extends and overrides styles. */
  styleExtension: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    container: PropTypes.shape({}),
    root: PropTypes.shape({}),
    label: PropTypes.shape({}),
    activeLabel: PropTypes.shape({}),
    stepIcon: PropTypes.shape({}),
    stepIconDanger: PropTypes.shape({}),
    stepIconSuccess: PropTypes.shape({}),
    stepIconWarning: PropTypes.shape({})
  })])
};
PizzaTracker.defaultProps = {
  'data-e2e': null,
  id: null,
  stepItems: [],
  successIcon: faCheck,
  styleExtension: {
    container: {},
    root: {},
    label: {},
    activeLabel: {},
    stepIcon: {},
    stepIconDefault: {},
    stepIconDanger: {},
    stepIconSuccess: {},
    stepIconWarning: {}
  }
};
PizzaTracker.displayName = 'PizzaTracker';
export default PizzaTracker;